import Code from '@tiptap/extension-code'
import Table from '@tiptap/extension-table'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import TableRow from '@tiptap/extension-table-row'
import { EditorProvider } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'
import { Markdown } from 'tiptap-markdown'
import { MenuBar } from './MenuBar'

type TiptapProps = {
  content: any
}

const Tiptap = ({ content }: TiptapProps) => {
  const extensions = [
    StarterKit as any,
    Markdown,
    Table.configure({
      resizable: true,
    }),
    TableRow,
    TableHeader,
    TableCell,
    Code,
  ]

  const editorProps = {
    attributes: {
      class:
        'prose prose-natural prose-base dark:prose-invert prose-headings:font-title font-default focus:outline-none max-w-full p-8 prose-table:border-collapse prose-table:border prose-table:border-gray-200 prose-table:text-sm prose-th:bg-gray-50 prose-th:font-semibold prose-th:px-2 prose-th:py-0 prose-th:border prose-th:border-gray-200 prose-td:px-2 prose-td:py-2 prose-td:border prose-td:border-gray-200 prose-td:text-left prose-p:m-0 prose-p:text-base prose-tbody:bg-white prose-tbody:rounded',
    },
  }

  return (
    <div className='bg-[#fff] shadow-sm rounded-lg border-[0.5px] border-[#00000001] min-h-[700px]'>
      <EditorProvider
        extensions={extensions}
        content={content}
        editorProps={editorProps}
        slotBefore={<MenuBar />}
      />
    </div>
  )
}

export default Tiptap
